import styled from 'styled-components';

import card from '../../styles/components/card';
import { COLOR_GRAY_30 } from 'styles/variables/colors';

export const Container = styled.div`
  width: 100%;
`;

export const Title = styled.h2`
  margin: 0 0 8px 0;
  font-size: 1.125rem;
  font-weight: bold;
`;

export const Card = styled.section`
  ${card}
`;

export const CardHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid ${COLOR_GRAY_30};
`;

export const CardBody = styled.div`
  padding: 20px 30px;
`;

export const Avatar = styled.img`
  height: 86px;
  width: 86px;
  border-radius: 50%;
  margin: 0 0 10px 0;
`;
